import { COUNTRY_PICKER_SET_COUNTRY, COUNTRY_PICKER_SET_OPEN } from '../constants';

export const countryPicker = (
    state = {
        isOpen: false,
        countryCode: "US",
        countries: [],
        hasSelectedCountry: false,
        active: false
    },
    action
) => {
    switch (action.type) {
        case COUNTRY_PICKER_SET_COUNTRY:
            return {
                ...state,
                ...action.payload,
            };
        case COUNTRY_PICKER_SET_OPEN:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
